// src/redux/slices/emailSlice.ts

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchEmail } from "@/services/api/EmailTemplate";

export const fetchEmailTemplate = createAsyncThunk(
  "email/fetchEmailTemplate",
  async (
    {
      pageNo = 1,
      perPage = 10,
      search = "",
    }: { pageNo?: number; perPage?: number; search?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchEmail(pageNo, perPage, search);
      return {
        results: response?.data?.results || [],
        totalRecord: response?.data?.totalRecord || 0,
      };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Error fetching email"
      );
    }
  }
);


const emailSlice = createSlice({
  name: "emailTemplate",
  initialState: {
    emailTemplate: [] as any[],
    totalRecords: 0,
    loading: false,
    error: null as string | null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmailTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.emailTemplate = action.payload.results;
        state.totalRecords = action.payload.totalRecord;

        console.log("email:", action.payload);
      })
      .addCase(fetchEmailTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default emailSlice.reducer;